import { useState, useEffect } from 'react';
import AgoraRTC from '../utils/AgoraEnhancer';

const noop = () => {};

const useCamera = () => {
  const [cameraList, setCameraList] = useState([]);

  useEffect(() => {
    let mounted = true;

    const updateCameraList = async () => {
      try {
        // SDK v4 usa método estático
        const cameras = await AgoraRTC.getCameras();
        if (mounted) {
          setCameraList(cameras);
        }
      } catch (err) {
        console.error('Error getting cameras:', err);
      }
    };

    // SDK v4 usa evento cameraChanged
    const handleDeviceChange = () => {
      updateCameraList();
    };

    // Listener para mudanças de dispositivo
    AgoraRTC.onCameraChanged = handleDeviceChange;

    // Carrega lista inicial
    updateCameraList();

    return () => {
      mounted = false;
      AgoraRTC.onCameraChanged = undefined;
    };
  }, []);

  return cameraList;
};

export default useCamera;
